import { useQuery } from '@apollo/client';
import _ from 'lodash';
import React from 'react';
import Activities from '../activities/Activities';
import EmptyState from '../components/EmptyState';
import RightPanel from '../components/RightPanel';
import CreatePostButton from '../post/CreatePostButton';
import ConnectionHelper from '../utils/graphql/ConnectionHelper';
import useSlug from '../utils/router/useSlug';
import * as styles from './TopicActivitiesPanel.module.scss';
import { gql } from '../graphql/generated/gql';

const TOPIC_ACTIVITIES_QUERY = gql(`
  query topicActivities($id: ID!, $afterCursor: String) {
    topic(id: $id) {
      id
      activities(first: 10, after: $afterCursor) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Activities_activities
          }
        }
      }
    }
  }
`);

interface TopicActivitiesPanelProps {
  close: () => void;
}

const TopicActivitiesPanel = ({ close }: TopicActivitiesPanelProps) => {
  const [topicId] = useSlug('topicSlug');

  const response = useQuery(TOPIC_ACTIVITIES_QUERY, {
    variables: { id: topicId },
  });

  const fetchMore = ConnectionHelper.generateFetchMore(
    TOPIC_ACTIVITIES_QUERY,
    response,
    'topic.activities',
  );

  const topic = response.data?.topic;
  const activities = topic?.activities
    ? _.compact(topic.activities.edges?.map((edge) => edge?.node))
    : [];

  return (
    <RightPanel header="Activity" close={close}>
      <div className={styles.content}>
        {activities.length > 0 ? (
          <Activities activities={activities} fetchMore={fetchMore} />
        ) : (
          <EmptyState
            title="No activity yet…"
            message="Activity will appear after a post has been created under this topic."
            action={
              <CreatePostButton
                size="large"
                variant="secondary"
                topicId={topicId}
              >
                Create a post
              </CreatePostButton>
            }
            vertical
          />
        )}
      </div>
    </RightPanel>
  );
};

export default TopicActivitiesPanel;
